/**
 * Created by Zeng Bo on 11/08/2017.
 */
angular.module('qkr').directive('noSpecialChar', () => ({
    require: 'ngModel',
    restrict: 'A',
    link(scope, element, attrs, ngModel) {
            ngModel.$parsers.push((inputValue) => {
            if (inputValue === null) {
                return '';
            }
            const cleanInputValue = inputValue.replace(/[^\w\s]/gi, '');
            if (cleanInputValue !== inputValue) {
                ngModel.$setViewValue(cleanInputValue);
                ngModel.$render();
            }
            return cleanInputValue;
        });
     }
}));




// WEBPACK FOOTER //
// ./src/directives/forms/no.special.char.validation.js